<template>
  <v-data-table
    :headers="headers"
    :items="leases"
    sort-by="id"
    class="elevation-1 dark-last-row"
    hide-default-footer
    item-key="id"
    :loading="loading"
    :expanded.sync="expanded"
    show-expand
  >
    <template v-slot:top>
      <v-toolbar
        flat
        color="accent"
      >
        <v-spacer></v-spacer>
        <v-dialog
          v-model="dialog"
          max-width="500px"
          scrollable
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              tile
              small
            >
              <v-icon dark>mdi-plus</v-icon>
              Add
            </v-btn>
          </template>
          <v-card flat color="accent">
            <v-card-title class="primary">
              <span class="title text-uppercase white--text">{{ formTitle }}</span>
            </v-card-title>

           <v-card-text class="pa-0">
              <ValidationObserver ref="observer1">
                <v-form ref="injuredsform">
                  <v-list flat color="accent" class="py-0">
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Start Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <v-menu
                                v-model="menu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="computedStartDateFormatted"
                                    label="Start Date"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    solo
                                    flat
                                    dark
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                v-model="editedItem.start_date"
                                @input="menu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">End Date</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="computedEndDateFormatted"
                                  label="End Date"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  solo
                                  flat
                                  dark
                              ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="editedItem.end_date"
                              @input="menu = false"
                              ></v-date-picker>
                          </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Monthly Rent</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-text-field
                                v-model="editedItem.monthly_rent"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Rental Increases</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-textarea
                                v-model="editedItem.rental_increases"
                                solo
                                flat
                                dark
                              ></v-textarea>
                        </v-list-item-action>
                    </v-list-item>             
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Insuarance Renewal</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-menu
                              v-model="menu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                          >
                              <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                  v-model="computedInsuaranceRenewalFormatted"
                                  label="Insuarance Renewal"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  solo
                                  flat
                                  dark
                              ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="editedItem.insuarance_renewal"
                              @input="menu = false"
                              ></v-date-picker>
                          </v-menu>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Tenant Name</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-text-field
                                v-model="editedItem.tenant_name"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Contact Name</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-text-field
                                v-model="editedItem.contact_name"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Phone</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-text-field
                                v-model="editedItem.phone"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                        </v-list-item-action>
                    </v-list-item>
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="font-weight-bold">Email</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                            <ValidationProvider v-slot="{ errors }" name="Email" rules="email">
                              <v-text-field
                                v-model="editedItem.email"
                                :error-messages="errors"
                                required
                                solo
                                flat
                                dark
                              ></v-text-field>
                            </ValidationProvider>
                        </v-list-item-action>
                    </v-list-item>   
                    <v-list-item class="form-row">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Notes</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                              <v-textarea
                                v-model="editedItem.notes"
                                required
                                solo
                                flat
                                dark
                              ></v-textarea>
                        </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-form>
              </ValidationObserver>
            </v-card-text>
            <v-card-actions class="accent">
              <v-btn
                large min-width="49%" color="white" text
                @click="close"
              >
                Cancel
              </v-btn>
              <v-btn
                large min-width="49%" color="primary" tile
                @click="save"
                :loading="loading"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card color="red">
            <v-card-title class="subtitle-2 justify-center white--text">Are you sure to delete this item?</v-card-title>
            <v-card-actions class="red darken-4">
              <v-spacer></v-spacer>
              <v-btn tile color="red--text" @click="deleteItemConfirm" :loading="loading">Yes</v-btn>
              <v-btn tile color="white darken-1" text @click="closeDelete">Cancel</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn small color="secondary" tile @click="editItem(item)">      
        <v-icon
        >
          mdi-pencil
        </v-icon>
      </v-btn>             
      <v-btn small color="primary" tile @click="deleteItem(item.id)">
        <v-icon
        color="white"
        >
        mdi-delete
      </v-icon>  
      </v-btn>  
    </template>
    <template v-slot:item.start_date="{ item }">
      <span>{{ formatDate(item.start_date) }}</span>
    </template>
    <template v-slot:item.end_date="{ item }">
      <span>{{ formatDate(item.end_date) }}</span>
    </template>
    <template v-slot:item.start_date="{ item }">
      <span>{{ formatDate(item.start_date) }}</span>
    </template>
    <template v-slot:item.insuarance_renewal="{ item }">
      <span>{{ formatDate(item.insuarance_renewal) }}</span>
    </template>
    <template v-slot:item.monthly_rent="{ item }">
      <span>{{ item.monthly_rent | currency }}</span>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        Notes: {{ item.notes }}
      </td>
      <td :colspan="headers.length">
        Rental Increases: {{ item.rental_increases }}
      </td>
    </template>
  </v-data-table>
</template>

<script>
    import axios from 'axios'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, setInteractionMode } from 'vee-validate'
    import mixin from '../mixin/main.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin],
        props: ['property'],
        data: () => ({
            loading: false,
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Tenant Name', value: 'tenant_name', sortable: false },
                { text: 'Contact Name', value: 'contact_name', sortable: false },
                { text: 'Email', value: 'email', sortable: false },
                { text: 'Phone', value: 'phone', sortable: false },
                {
                  text: 'Start Date',
                  align: 'start',
                  sortable: false,
                  value: 'start_date',
                },
                { text: 'End Date', value: 'end_date', sortable: false },
                { text: 'Monthly Rental(1st Yr)', value: 'monthly_rent', sortable: false },
                { text: 'Insuarance Renewal', value: 'insuarance_renewal', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false, align: 'right' },
                { text: '', value: 'data-table-expand' },
            ],
            leases: [],
            editedIndex: -1,
            editedItem: {
                id: '',
                start_date: '',
                end_date: '',
                monthly_rent: '',
                rental_increases: '',
                insuarance_renewal: '',
                notes: '',
                tenant_name: '',
                contact_name: '',
                phone: '',
                email: '',
            },
            defaultItem: {
                id: '',
                start_date: '',
                end_date: '',
                monthly_rent: '',
                rental_increases: '',
                insuarance_renewal: '',
                notes: '',
                tenant_name: '',
                contact_name: '',
                phone: '',
                email: '',
            },
        }),

        components: {
            ValidationObserver,
        },

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Lease' : 'Edit Lease'
            },
            computedStartDateFormatted () {
                return this.formatDate(this.editedItem.start_date)
            },
            computedEndDateFormatted () {
                return this.formatDate(this.editedItem.end_date)
            },
            computedInsuaranceRenewalFormatted () {
                return this.formatDate(this.editedItem.insuarance_renewal)
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
        },

        created () {
            this.getLeases()
        },

        methods: {
            getLeases() {
                if(this.property) {
                    this.loading = true
                    axios.get('lease/all?id=' + this.property)
                        .then(response => {
                            this.loading = false
                            this.leases = response.data
                            this.$nextTick()
                        })
                }
            },

            editItem (item) {
                this.editedIndex = this.leases.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
            },

            deleteItem (item) {
                this.editedIndex = this.leases.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            deleteItemConfirm () {
                this.loading = true
                axios.delete('lease/delete?id=' + this.editedIndex)
                    .then(() => {
                      this.closeDelete()
                      this.getLeases()
                      this.$nextTick()
                    })
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
                })
            },

            async save () {
                if (this.editedIndex > -1) {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      axios.post('lease/update', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getLeases()
                          this.close()
                      }).catch(error => {
                          console.log(error)
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                } else {
                  let valid1 = await this.$refs.observer1.validate()

                  if(valid1) {
                      this.loading = true
                      this.$set(this.editedItem, 'property_id', this.property)
                      axios.post('lease/store', this.editedItem).then(() => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'green')
                          this.$store.commit('SET_SNACK', 'Successfully saved!')
                          this.getLeases()
                          this.close()
                      }).catch(error => {
                          this.loading = false
                          this.$store.commit('SET_SNACKTYPE', 'red')
                          if(error.response.data.error) {
                              this.$store.commit('SET_SNACK', error.response.data.error)
                          } else {
                              this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                          }
                      })
                  } else {
                      this.$store.commit('SET_SNACKTYPE', 'red')
                      this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                  }
                }
            },
        },
    }
</script>